"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parse = exports.decode = exports.stringify = exports.encode = void 0;
const primitive = (value) => {
    if (value === null || value === undefined)
        return '';
    switch (typeof value) {
        case 'string':
            return value;
        case 'boolean':
            return value ? 'true' : 'false';
        case 'number':
            return Number.isFinite(value) ? value.toString() : '';
        default:
            return '';
    }
};
const encode = (obj) => {
    if (obj === null || obj === undefined) {
        return '';
    }
    if (typeof obj === 'object') {
        const params = new URLSearchParams();
        Object.entries(obj).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                value.forEach(v => params.append(key, primitive(v)));
            }
            else {
                params.append(key, primitive(value));
            }
        });
        return params.toString();
    }
    return '';
};
exports.encode = encode;
exports.stringify = exports.encode;
const decode = (queryString) => {
    if (!queryString || typeof queryString !== 'string') {
        return {};
    }
    const params = new URLSearchParams(queryString);
    const result = {};
    params.forEach((_, key) => {
        const values = params.getAll(key);
        result[key] = values.length === 1 ? values[0] : values;
    });
    return result;
};
exports.decode = decode;
exports.parse = exports.decode;
//# sourceMappingURL=querystring.js.map